import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Card } from '@grandvisionhq/common';
import { useFormatter } from '@grandvisionhq/frk-routing';
import { ButtonOutline } from '@grandvisionhq/iris-ui';
import { LineItemMappers, LineItemSlotsProvider, LineItemCard, InsurancePolicy } from '@grandvisionhq/lib-visuals';
import StoreDetailModal from '../../Appointments/components/StoreDetailModal/StoreDetailModal.js';
import { useCancelAndReturnsModalContentSlot } from '../../context/CancelAndReturnsModalContentContext.js';
import { isGlassesBundleOrderLineItem } from '../models/line-items.js';
import { useAddressFormSlotsContext } from '../../slots/AddressFormSlotsContext.js';
import { useStoreAddressFormSlotsContext } from '../../slots/StoreAddressFormSlotsContext.js';
import DetailFooterContainer from '../components/Footer/DetailFooter/DetailFooterContainer.js';
import { Order } from '../components/Order/Order.js';
import Reorder from '../components/Reorder/Reorder.js';

const OrderDetail = ({ dateTime , labels , onCloseStoreDetailModal , onOpenStoreDetailModal , onTraceOrder , onReorder , onOpenCancelReturnsModal , onCloseCancelReturnsModal , onDownloadReceiptClick , onClickReturn , isCancelReturnsModalOpen , detail , lineItems , shipments , isModalOpen , storeName , currency , prescriptionsUrl , isReorderAvailable , isReturnsEnabled , isOrderWorkflowStatusEnabled , isPaid , returnUrl , shouldShowOrderDate ,  })=>{
    var ref2;
    const { Slots: { summary: AddressSummaryTemplate  } ,  } = useAddressFormSlotsContext();
    const { Slots: { summary: StoreAddressSummaryTemplate  } ,  } = useStoreAddressFormSlotsContext();
    useCancelAndReturnsModalContentSlot();
    const format = useFormatter();
    const lineItemsWithInsurance = lineItems.flatMap((lineItem)=>lineItem.insurance ? [
            toVisualLineItem(lineItem)
        ] : []
    ).filter((item)=>item !== undefined
    );
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-detail"
    }, /*#__PURE__*/ React.createElement(Order, {
        className: "order-details__order",
        labels: labels,
        onReorder: isReorderAvailable ? onReorder : undefined,
        shipmentTrackingUrl: detail.shipmentTrackingUrl,
        footer: /*#__PURE__*/ React.createElement(DetailFooterContainer, {
            paymentMethod: detail.paymentMethod,
            subtotal: detail.subtotalAmount,
            discount: detail.discountedAmount,
            shippingCost: detail.shippingMethodPrice,
            total: detail.totalPrice,
            donation: detail.donation
        }),
        orderDate: detail.orderDate,
        orderNumber: detail.orderNumber,
        shipmentStatus: detail.shipmentStatus,
        orderStatus: detail.orderStatus,
        receiptUrl: detail.receiptUrl,
        returnUrl: returnUrl,
        paymentStatus: detail.paymentStatus,
        onTraceOrder: onTraceOrder,
        onOpenCancelReturnsModal: onOpenCancelReturnsModal,
        onCloseCancelReturnsModal: onCloseCancelReturnsModal,
        onDownloadReceiptClick: onDownloadReceiptClick,
        onClickReturn: onClickReturn,
        isCancelReturnsModalOpen: isCancelReturnsModalOpen,
        isPaid: isPaid,
        isOrderReturnable: detail.isOrderReturnable,
        isReturnsEnabled: isReturnsEnabled,
        isOrderWorkflowStatusEnabled: isOrderWorkflowStatusEnabled,
        shouldShowOrderDate: shouldShowOrderDate
    }, shipments.length > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, shipments.map((shipment, shipmentIndex)=>{
         return React.createElement(Card.Section, {
            key: shipment.id + shipmentIndex,
            className: "order-detail__shipment"
        }, /*#__PURE__*/ React.createElement(Card.Heading, {
            variant: "smallest"
        }, labels.shipment, ' ', shipment.shippingDate && `${dateTime.formatNarrowDate(shipment.shippingDate)}`), /*#__PURE__*/ React.createElement("div", {
            className: "shipment-header"
        }, /*#__PURE__*/ React.createElement("div", null, shipment.trackingUrl && /*#__PURE__*/ React.createElement(Card.Link, {
            href: shipment.trackingUrl,
            target: "_blank",
            iconBefore: "delivery",
            onClick: onTraceOrder
        }, labels.trackingURL)), /*#__PURE__*/ React.createElement("div", null, isReturnsEnabled ? /*#__PURE__*/ React.createElement(React.Fragment, null, detail.isOrderReturnable && returnUrl ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Card.Link, {
            iconBefore: "returns",
            href: returnUrl,
            onClick: onClickReturn
        }, shipments.length > 1 ? labels.cancelAndReturnShipment : labels.cancelAndReturns)) : null) : null)), shipment.lineItems.map((item, i)=>{
            var ref;
            const { sku , slug , productType , originalProductType  } = item;
            const key = productType == 'prescription-glasses' ? originalProductType : productType;
            var ref1;
            const imageHref = (ref1 = format({
                route: 'products.detail',
                params: {
                    sku,
                    slug,
                    key
                }
            })) !== null && ref1 !== void 0 ? ref1 : undefined;
            const accordionSection = [];
            if ('prescription' in item) {
                if (isGlassesBundleOrderLineItem(item)) {
                    accordionSection.push({
                        type: 'GLASSES_BUNDLE',
                        title: labels.prescription,
                        prescription: item.prescription,
                        prescriptionsUrl
                    });
                } else if (item.prescription) {
                    accordionSection.push({
                        type: 'CONTACT_LENSES',
                        title: labels.prescription,
                        prescription: item.prescription
                    });
                }
            }
            if (item.isSubscription && ((ref = item.subscriptionDetails) === null || ref === void 0 ? void 0 : ref.deliveryInterval)) {
                accordionSection.push({
                    type: 'SUBSCRIPTION',
                    title: labels.subscriptionDetails,
                    expanded: true,
                    deliveryInterval: item.subscriptionDetails.deliveryInterval
                });
            }
            if (isGlassesBundleOrderLineItem(item) && item.bundleChildLineItems) {
                const bundleChildLineItems = LineItemMappers.getEnrichedBundleChildLineItems({
                    lineItem: item,
                    addOnLabel: labels.addOn
                });
                accordionSection.push({
                    type: 'GENERIC_BUNDLE',
                    title: labels.configuration,
                    bundleChildLineItems
                });
            }
            const lineItemCardProps = {
                currency,
                discount: item.discountPrice,
                originalPrice: item.originalPrice,
                imagePath: item.imageUrl,
                lineItemId: item.lineItemId,
                price: item.price,
                quantity: item.quantity,
                subtitle: item.subtitle,
                title: item.title,
                imageHref,
                accordionSection,
                additionalInfo: item.additionalInfo
            };
            const LineItemCardSlot = {
                Reorder: ()=>/*#__PURE__*/ React.createElement(Reorder, {
                        id: item.lineItemId,
                        isReorderAvailable: Boolean(item.isReorderAvailable),
                        onReorder: onReorder
                    })
            };
            return /*#__PURE__*/ React.createElement(LineItemSlotsProvider, {
                key: `${shipment.id}-${item.lineItemId}-${i}`,
                slots: LineItemCardSlot
            }, /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({}, lineItemCardProps)));
        }));
    })), lineItems.length > 0 && /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__info"
    }, /*#__PURE__*/ React.createElement(Card.Heading, {
        variant: "smallest"
    }, shipments.length === 0 ? labels.yourOrderDetails : lineItems.length > 1 ? `${labels.itemsToBeShipped} (${lineItems.length})` : labels.itemToBeShipped)), lineItems.length > 0 && (lineItems === null || lineItems === void 0 ? void 0 : lineItems.map((item, i)=>{
        var ref5;
        const { sku , slug , productType , originalProductType  } = item;
        const key = productType == 'prescription-glasses' ? originalProductType : productType;
        var ref3;
        const imageHref = (ref3 = format({
            route: 'products.detail',
            params: {
                sku,
                slug,
                key
            }
        })) !== null && ref3 !== void 0 ? ref3 : undefined;
        const accordionSection = [];
        if ('prescription' in item) {
            if (isGlassesBundleOrderLineItem(item)) {
                accordionSection.push({
                    type: 'GLASSES_BUNDLE',
                    title: labels.prescription,
                    prescription: item.prescription,
                    prescriptionsUrl
                });
            } else if (item.prescription) {
                accordionSection.push({
                    type: 'CONTACT_LENSES',
                    title: labels.prescription,
                    prescription: item.prescription
                });
            }
        }
        if (item.isSubscription && ((ref5 = item.subscriptionDetails) === null || ref5 === void 0 ? void 0 : ref5.deliveryInterval)) {
            accordionSection.push({
                type: 'SUBSCRIPTION',
                title: labels.subscriptionDetails,
                expanded: true,
                deliveryInterval: item.subscriptionDetails.deliveryInterval
            });
        }
        if (isGlassesBundleOrderLineItem(item) && item.bundleChildLineItems) {
            const bundleChildLineItems = LineItemMappers.getEnrichedBundleChildLineItems({
                lineItem: item,
                addOnLabel: labels.addOn
            });
            accordionSection.push({
                type: 'GENERIC_BUNDLE',
                title: labels.configuration,
                bundleChildLineItems
            });
        }
        const lineItemCardProps = {
            currency,
            discount: item.discountPrice,
            originalPrice: item.originalPrice,
            imagePath: item.imageUrl,
            lineItemId: item.lineItemId,
            price: item.price,
            quantity: item.quantity,
            subtitle: item.subtitle,
            title: item.title,
            imageHref,
            accordionSection,
            additionalInfo: item.additionalInfo
        };
        const LineItemCardSlot = {
            Reorder: ()=>/*#__PURE__*/ React.createElement(Reorder, {
                    id: item.lineItemId,
                    isReorderAvailable: Boolean(item.isReorderAvailable),
                    onReorder: onReorder
                })
            ,
            DeliveryEstimation: undefined
        };
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LineItemSlotsProvider, {
            slots: LineItemCardSlot
        }, /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
            key: `${item.lineItemId}-${i}`
        }, lineItemCardProps))));
    }))), lineItemsWithInsurance.length > 0 && detail.rawPaymentStatus !== 'FAILED' && /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__info"
    }, /*#__PURE__*/ React.createElement(Card.Heading, {
        variant: "smallest"
    }, labels.insuranceDetails)), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(InsurancePolicy, {
        lineItems: lineItemsWithInsurance
    }))), /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__info"
    }, /*#__PURE__*/ React.createElement(Card.Heading, {
        variant: "smallest"
    }, labels.orderDetails)), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.shipmentMethodTitle), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, null, labels.makeDeliveryMethodName(detail === null || detail === void 0 ? void 0 : detail.shippingInfo)), // if shippingInfo is 'pick-up' then show store-info card
    (detail === null || detail === void 0 ? void 0 : detail.shippingInfo) === 'pick-up' && /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(Card.Link, {
        iconAfter: "chevron-right",
        onClick: onOpenStoreDetailModal
    }, labels.storeInfo))))), /*#__PURE__*/ React.createElement(Card.Section, null, (detail === null || detail === void 0 ? void 0 : (ref2 = detail.shippingAddress) === null || ref2 === void 0 ? void 0 : ref2.externalId) && isModalOpen && /*#__PURE__*/ React.createElement(StoreDetailModal, {
        globalStoreId: detail.shippingAddress.externalId,
        onModalClose: onCloseStoreDetailModal
    }), /*#__PURE__*/ React.createElement(Card.Section, {
        flex: true,
        className: "order-details__items"
    }, /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__detail",
        spacing: "none"
    }, detail.shippingAddress && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.shipmentAddress), // if shippingInfo is 'pick-up' then show store-info card
    (detail === null || detail === void 0 ? void 0 : detail.shippingInfo) === 'pick-up' && StoreAddressSummaryTemplate ? /*#__PURE__*/ React.createElement(StoreAddressSummaryTemplate, {
        storeName: storeName,
        values: swcHelpers.objectSpread({}, detail.shippingAddress)
    }) : null, (detail === null || detail === void 0 ? void 0 : detail.shippingInfo) !== 'pick-up' && AddressSummaryTemplate ? /*#__PURE__*/ React.createElement(AddressSummaryTemplate, {
        values: swcHelpers.objectSpread({}, detail.shippingAddress)
    }) : null)), detail.billingAddress && /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__detail",
        spacing: "none"
    }, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.billingAddress), AddressSummaryTemplate ? /*#__PURE__*/ React.createElement(AddressSummaryTemplate, {
        values: swcHelpers.objectSpread({}, detail.billingAddress)
    }) : null))), /*#__PURE__*/ React.createElement(Card.Section, {
        className: "order-details__invoice-info"
    }, isPaid && detail.receiptUrl && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body",
        className: "invoice-info-text"
    }, labels.invoiceDetails), /*#__PURE__*/ React.createElement(ButtonOutline, {
        className: "invoice-button",
        href: detail.receiptUrl,
        component: "a",
        onPress: ()=>onDownloadReceiptClick()
    }, labels.downloadReceipt))));
};
/** Utils **/ const toVisualLineItem = (orderLineItem)=>{
    if (orderLineItem.type === 'CONTACT_LENSES') {
        return swcHelpers.objectSpread({}, orderLineItem, {
            productUrl: ''
        });
    }
    // Do not include legacy types, such as CONTACT_LENS_BUNDLE
    if (orderLineItem.type === 'REGULAR' || orderLineItem.type === 'SOLUTION' || orderLineItem.type === 'GLASSES_BUNDLE' || orderLineItem.type === 'NON_PRESCRIPTION_BUNDLE') {
        return swcHelpers.objectSpread({}, orderLineItem, {
            productUrl: ''
        });
    }
};

export { OrderDetail as default };
//# sourceMappingURL=OrderDetail.js.map
